import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const pricesApi = axios.create({
  baseURL: API_BASE_URL + "allpriceapi",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
